import config from 'config';
import { authHeader } from '../_helpers';

export const bookingReferenceService = {
    logout,
    getBookingReference,
    getBookingReferences,
    submitBookingReference,
    deleteBookingReference
};

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('token');
}

function getBookingReference(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/booking_reference/` + id, requestOptions).then(handleResponse);
}

function getBookingReferences(formData) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    var queryString = new URLSearchParams(formData).toString();

    return fetch(`${config.apiUrl}/booking_reference` + '?' + queryString, requestOptions).then(handleResponse);
}

function submitBookingReference(addressData) {
    var headers = authHeader();
    headers['Content-Type'] = 'application/json';
    const requestOptions = {
        crossDomain: true,
        method: 'POST',
        headers: headers,
        body: JSON.stringify(addressData)
    };

    var url = new URL(`${config.apiUrl}/booking_reference`);
    return fetch(url, requestOptions).then(handleResponse);
}

function deleteBookingReference(id) {

    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    }

    return fetch(`${config.apiUrl}/booking_reference/` + id, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                if(response.url !== `${config.apiUrl}/auth/login`)
                    location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}